import createEvent from './create-event';

window.addEventListener('load', function(){
    let ld = $('.loader');
    setTimeout(function () {
        document.documentElement.dispatchEvent(createEvent('homePageLoad'));
        ld.addClass('hide');
    }, 1200);
    setTimeout(function () {
        document.documentElement.dispatchEvent(createEvent('isLoaded'));
    }, 1500);
    setTimeout(function () {
        ld.remove();
    },2000);
});



// WEBPACK FOOTER //
// ./scripts/loader.js